import { render } from "./Aspect.vue?vue&type=template&id=6d03ab12"
import script from "./Aspect.vue?vue&type=script&lang=js"
export * from "./Aspect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__